
import { mapGetters, mapActions } from "vuex";
export default {
	components: {
		breadcrumbs	: () => import('../../components/pages/breadcrumbs.vue'),
		vcLoading	: () => import('../../components/pages/loading.vue'),
        vcFormField	: () => import("../../components/pages/form-field.vue"),
		formPassword: () => import('../../components/pages/form-password.vue')
	},
	data() {
		return {
			isLoading: null,
			email: null,
			availableChangePassword: false,
		}
	},
	computed:{
		...mapGetters({
			getterTranslates: 'getterTranslates',
			getterStoreLang : 'getterStoreLang',
			getterValidCustomer: "getterValidCustomer",
			getterChangePassword: "getterChangePassword"
		}),
		getUserEmail(){
			return this.email;
		}
	},
	mounted(){
		this.$root.$on('change-loading', this.updateLoading);
		this.$root.$on('update-field-value', this.updateFieldValue);
	},
	methods: {
		...mapActions({
			validCustomer: "validCustomer"
		}),
		updateFieldValue(data){
            this[data.field] = data.value;
		},
		updateLoading(dataLoading){
			
			this.isLoading = dataLoading;
		},
		async validCustomerEmail(){
			this.isLoading = true;
			await this.validCustomer({ email: this.email }).then( (result_customer) => {
				
				this.resultValidCustomerEmail();
			}).catch( (error_customer) => {
				
				this.resultValidCustomerEmail();
			});
		},
		resultValidCustomerEmail(){
			
			this.isLoading = null;
			this.availableChangePassword = this.getterValidCustomer.success;
		}
	}
}
